import { Box, Grid, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { usePlan } from "../../Plans"
import { ISettingsItem, useSettings } from "../../Settings"
import { useTranslation } from "../../i18n"
import logoDefault2 from '../../assets/images/logoDefault2.svg'

export default function FooterHeading({ name, variables }: ISettingsItem) {
  const navigate = useNavigate()
  const { planIndex } = usePlan()
  const { pageTitle, companyAddress } = useSettings()
  const { t } = useTranslation()
  const defaultTextArray = [`${t.footer.copyrightPrefix} ${pageTitle || t.footer.copyrightFallbackBrand}. ${t.footer.copyrightSuffix}`, companyAddress || '']
  const { image = [logoDefault2], text = defaultTextArray } = variables || {}
  const currentLogo = image[planIndex] || image[0]

  return (
    <Grid item className={name ? `${name} footer-heading` : "footer-heading"}>
      <Grid
        className="heading-logo"
        onClick={() => {
          navigate('/')
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }}
        sx={{ cursor: 'pointer', zIndex: '100' }}
      >
        <Box component="img" src={currentLogo} alt="Logo do footer" />
      </Grid>
      <Grid className="heading-text">
        <Typography variant="body2" dangerouslySetInnerHTML={{ __html: text[0] }} />
        {text[1] !== '' && <Typography variant="body2" dangerouslySetInnerHTML={{ __html: text[1] }} />}
      </Grid>
    </Grid>
  )
}